import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { identityProvider }: Boundaries["removeIdentityProvider"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.identityProvider.uuid === identityProvider.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToPending(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { identityProvider, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { identityProvider }: Boundaries["removeIdentityProvider"]["success"],
): State {
  const index = state.findIndex(
    (req) => req.identityProvider.uuid === identityProvider.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToSuccess(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { identityProvider, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { identityProvider }: Boundaries["removeIdentityProvider"]["failure"],
): State {
  const index = state.findIndex(
    (req) => req.identityProvider.uuid === identityProvider.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToFailure(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { identityProvider, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.removeIdentityProviderRequested]: handleRequest,
  [events.removeIdentityProviderSucceeded]: handleSuccess,
  [events.removeIdentityProviderFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
